import loadScript from 'chairisher/util/script';

import { getAppleAuthJSUrl } from 'chairisher/context/script';

let applePromise;

// **NOTE**: This file is separate impl of the apple loader for webpack only.
//           It overwrites apple.js at compile time. Any logic changes should be duplicated for now.
// TODO (CHAIR-15663): Delete this file after migration is complete.

/**
 * @returns {Promise}
 */
function loadAuth() {
    if (applePromise) {
        return applePromise;
    }

    applePromise = loadScript({ scriptName: 'AppleID', scriptSrc: getAppleAuthJSUrl() });

    return applePromise;
}

export default { loadAuth };
